//commit1
<template>
    <div id="root">
        <div class="wrapper">
            <div class="language-mb">
                <img src="@/assets/images/flag.png" />
                Tiếng Việt&nbsp;
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.40725 11.9475L15.381 5.6779C15.4807 5.57329 15.5364 5.4343 15.5364 5.28977C15.5364 5.14524 15.4807 5.00626 15.381 4.90165L15.3743 4.8949C15.3259 4.84401 15.2677 4.80349 15.2032 4.7758C15.1387 4.7481 15.0693 4.73383 14.9991 4.73383C14.9289 4.73383 14.8594 4.7481 14.7949 4.7758C14.7304 4.80349 14.6722 4.84401 14.6239 4.8949L8.99888 10.7989L3.37613 4.8949C3.32779 4.84401 3.26959 4.80348 3.20509 4.77579C3.14059 4.7481 3.07114 4.73382 3.00094 4.73382C2.93075 4.73382 2.86129 4.7481 2.79679 4.77579C2.73229 4.80348 2.6741 4.84401 2.62575 4.8949L2.619 4.90165C2.51928 5.00626 2.46365 5.14524 2.46365 5.28977C2.46365 5.4343 2.51928 5.57328 2.619 5.6779L8.59275 11.9475C8.64529 12.0027 8.70847 12.0466 8.77848 12.0765C8.84848 12.1065 8.92385 12.122 9 12.122C9.07616 12.122 9.15153 12.1065 9.22153 12.0765C9.29154 12.0466 9.35472 12.0027 9.40725 11.9475Z"
                          fill="#939598" />
                </svg>

                <ul class="language-opt">
                    <li>
                        <a href="javascript:void(0)"><img src="@/assets/images/UKflag.png" alt="" />English</a>
                    </li>
                    <li>
                        <a href="javascript:void(0)"><img src="@/assets/images/VNflag.png" alt="" />Tiếng Việt</a>
                    </li>
                </ul>
            </div>
            <img src="@/assets/images/logo-myvtc.png" class="form-logo-mb" />
            <div class="form-img">
                <img :src="randomImage" />
            </div>
            <div class="form">
                <a href="javascript:void(0)" class="language">
                    <img src="@/assets/images/VNflag.png" />
                    Tiếng Việt
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                        <path d="M7.40727 7.94746L13.381 1.67784C13.4807 1.57322 13.5364 1.43424 13.5364 1.28971C13.5364 1.14518 13.4807 1.0062 13.381 0.901587L13.3743 0.894836C13.3259 0.843946 13.2677 0.803425 13.2032 0.775734C13.1387 0.748044 13.0693 0.733764 12.9991 0.733764C12.9289 0.733764 12.8594 0.748043 12.7949 0.775734C12.7304 0.803425 12.6722 0.843946 12.6239 0.894836L6.99889 6.79884L1.37615 0.894835C1.3278 0.843945 1.26961 0.803424 1.20511 0.775733C1.14061 0.748042 1.07115 0.733763 1.00096 0.733763C0.930766 0.733763 0.861307 0.748042 0.796807 0.775733C0.732308 0.803424 0.674116 0.843945 0.62577 0.894835L0.61902 0.901585C0.519294 1.0062 0.463662 1.14518 0.463662 1.28971C0.463662 1.43424 0.519294 1.57322 0.61902 1.67783L6.59277 7.94746C6.6453 8.0026 6.70849 8.0465 6.77849 8.07649C6.8485 8.10648 6.92386 8.12195 7.00002 8.12195C7.07618 8.12195 7.15154 8.10648 7.22155 8.07649C7.29155 8.0465 7.35474 8.0026 7.40727 7.94746Z"
                              fill="#D9D9D9"></path>
                    </svg>
                </a>

                <img src="@/assets/images/form-logo.png" class="form-logo" />
                <main>
                    <slot />
                </main>
                <div class="form-bottom">
                    <a href="javascript:void(0)" @click="openPolicyUrl">Chính sách</a>
                    <a href="javascript:void(0)" @click="openTermsOfUseUrl">Điều khoản</a>
                </div>
            </div>
            <div class="form-bottom-mb">
                <a href="javascript:void(0)">Chính sách</a>
                <a href="javascript:void(0)">Điều khoản</a>
            </div>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    export default {
        data() {
            return {

            }
        },
        methods: {
            openPolicyUrl() {
                window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/chinh-sach`, '_blank');
            },
            openTermsOfUseUrl() {
                window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/dieu-khoan`, '_blank');
            }
        },
        computed: {

        },
        setup() {
            const randomImage = ref('');
            const generateRandomImage = () => {
                // Tạo ngẫu nhiên từ 1 đến 3 để lấy tên ảnh
                const randomIndex = Math.floor(Math.random() * 3) + 1;
                randomImage.value = require(`@/assets/images/signup${randomIndex}.png`);
            };

            // Đổi ảnh ngẫu nhiên khi component được mount lần đầu
            onMounted(generateRandomImage);
            return { randomImage };
        }
    };
</script>

<style>
    @import url(../assets/css/style.css);
</style>